var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrust1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 22.6666L17.3337 25.3333C17.5963 25.596 17.9081 25.8043 18.2513 25.9464C18.5944 26.0886 18.9622 26.1617 19.3337 26.1617C19.7051 26.1617 20.0729 26.0886 20.4161 25.9464C20.7592 25.8043 21.071 25.596 21.3337 25.3333C21.5963 25.0707 21.8046 24.7589 21.9468 24.4157C22.0889 24.0725 22.1621 23.7047 22.1621 23.3333C22.1621 22.9619 22.0889 22.5941 21.9468 22.2509C21.8046 21.9078 21.5963 21.596 21.3337 21.3333",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 18.6667L22.0003 22C22.5307 22.5304 23.2502 22.8284 24.0003 22.8284C24.7504 22.8284 25.4699 22.5304 26.0003 22C26.5307 21.4696 26.8287 20.7501 26.8287 20C26.8287 19.2499 26.5307 18.5304 26.0003 18L20.827 12.8267C20.077 12.0776 19.0603 11.6569 18.0003 11.6569C16.9403 11.6569 15.9236 12.0776 15.1736 12.8267L14.0003 14C13.4699 14.5304 12.7504 14.8284 12.0003 14.8284C11.2502 14.8284 10.5307 14.5304 10.0003 14C9.46987 13.4696 9.17188 12.7501 9.17188 12C9.17188 11.2499 9.46987 10.5304 10.0003 10L13.747 6.25333C14.9633 5.04019 16.5495 4.2674 18.2545 4.0573C19.9595 3.84719 21.6859 4.21177 23.1603 5.09333L23.787 5.46667C24.3547 5.80932 25.0297 5.92816 25.6803 5.8L28.0003 5.33333",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 4L29.3337 18.6667H26.667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 4L2.66699 18.6667L11.3337 27.3333C11.8641 27.8638 12.5835 28.1618 13.3337 28.1618C14.0838 28.1618 14.8032 27.8638 15.3337 27.3333C15.8641 26.8029 16.1621 26.0835 16.1621 25.3333C16.1621 24.5832 15.8641 23.8638 15.3337 23.3333",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33331H14.6667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust1);
export default __webpack_public_path__ + "static/media/trust-1.439242f13b0d8aa5ef25a3797c04b05f.svg";
export { ForwardRef as ReactComponent };